import { ExternalRateServices } from './components/externalRate/utils';

export const SYSTEM_ROLES = [
  { name: 'admin', displayname: 'Admin' },
  { name: 'manager', displayname: 'Manager' },
  { name: 'user', displayname: 'Employee' },
];

export const TOPBAR_HEIGHT = 44;

export const BOOK_CALL_DEFAULT_SLING_PM = 'https://calendly.com/robin-jauch/30min';
export const BOOK_CALL_SCHEDULE_EXPERIENCE_PM =
  'https://calendly.com/emily-worthington-sling/scheduling-experience-feedback';
export const EXTERNAL_RATE_SERVICES = {
  [ExternalRateServices.g2]: {
    url: 'https://www.g2.com/products/sling/reviews/start',
    name: 'G2',
  },
  [ExternalRateServices.capterra]: {
    url: 'https://reviews.capterra.com/new/142542',
    name: 'Capterra',
  },
  [ExternalRateServices.shopify]: {
    url: 'https://apps.shopify.com/sling?surface_detail=Sling&surface_inter_position=1&surface_intra_position=1&surface_type=search#reviews',
    name: 'Shopify',
  },
};

// LocalStorage key under which we keep clientCache values.
// Client cache is an object with any values that we want to
// preserve on one particular device but not transfer to other devices or browsers.
export const CLIENT_CACHE_KEY = 'ngStorage-clientcache';
export const CLIENT_SETTINGS_KEY = 'ngStorage-clientsettings';

export const DEFAULT_CACHE_TIME = 1000 * 60 * 60 * 24;
export const DEFAULT_STALE_TIME = Infinity;
